export default "__VITE_ASSET__nZRd1ta3__"